import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { Checkboxes } from '../../../FlowConfigurationInputs';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function WriteCell({ action, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.WRITE-CELL.';
    const [rangeType, setRangeType] = useState(action.fields.rangeType?.value ? action.fields.rangeType.value : 'custom');

    useEffect(() => {
        // Assign initial values
        if (!action.fields.range) {
            action.fields.range = { value: '', isRequired: true };
        }
        if (!action.fields.rangeType || action.fields.rangeType?.value === '') {
            action.fields.rangeType = { value: 'custom' }
            setRangeType('custom');
        } else {
            setRangeType(action.fields.rangeType.value);
        }
        if (!action.fields.value) {
            action.fields.value = { value: '', isRequired: true };
        }
    }, [action]);

    function changeRangeType(v) {
        action.fields.rangeType = { value: v }
        setRangeType(v);
    }

    return (
        <>
            <div className="conf-field-container">
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'EXCEL-SOURCE')} is_required />
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                    <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'RANGE-TYPE')} is_required />
                <div className="condition-tabs">
                    <button
                        className={`f-s-11 ${rangeType === 'custom' ? 'condition-active' : ''}`}
                        onClick={() => changeRangeType('custom')}>
                        {t(label + 'CUSTOM-RANGE')}
                    </button>
                    <button
                        className={`f-s-11 ${rangeType === 'last' ? 'condition-active' : ''}`}
                        onClick={() => changeRangeType('last')}>
                        {t(label + 'ADD-TO-LAST-ROW')}
                    </button>
                </div>
                <FieldLabel name={t(rangeType === 'custom' ? label + 'RANGE' : label + 'COLUMN')} is_required />
                <TextInput action={action} inputName="range" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired displayName={t(label + (rangeType === 'custom' ? 'RANGE' : 'COLUMN'))}
                    fieldType={rangeType === 'custom' ? 'string-range' : "string-single-column"} hideRequired />
                <small className="conf-field-desc"><em>{t(rangeType === 'custom' ? label + 'RANGE-EG' : label + 'COLUMN-EG')}</em></small>
            </div>
            <div className="conf-field-container">
                <Checkboxes action={action} inputName="rowContainsIndex" options={{ label: label + 'ROW-CONTAINS-INDEX' }} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'VALUE')} is_required />
                <TextInput action={action} inputName="value" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired hideRequired />
            </div>
        </>
    )
}

export default WriteCell;